/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RequestCreateInboundPlanRequest } from './RequestCreateInboundPlanRequest';
import {
    RequestCreateInboundPlanRequestFromJSON,
    RequestCreateInboundPlanRequestFromJSONTyped,
    RequestCreateInboundPlanRequestToJSON,
    RequestCreateInboundPlanRequestToJSONTyped,
} from './RequestCreateInboundPlanRequest';

/**
 * 
 * @export
 * @interface RequestCreateInboundPlansRequest
 */
export interface RequestCreateInboundPlansRequest {
    /**
     * 
     * @type {Array<RequestCreateInboundPlanRequest>}
     * @memberof RequestCreateInboundPlansRequest
     */
    plans: Array<RequestCreateInboundPlanRequest>;
}

/**
 * Check if a given object implements the RequestCreateInboundPlansRequest interface.
 */
export function instanceOfRequestCreateInboundPlansRequest(value: object): value is RequestCreateInboundPlansRequest {
    if (!('plans' in value) || value['plans'] === undefined) return false;
    return true;
}

export function RequestCreateInboundPlansRequestFromJSON(json: any): RequestCreateInboundPlansRequest {
    return RequestCreateInboundPlansRequestFromJSONTyped(json, false);
}

export function RequestCreateInboundPlansRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestCreateInboundPlansRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'plans': ((json['plans'] as Array<any>).map(RequestCreateInboundPlanRequestFromJSON)),
    };
}

export function RequestCreateInboundPlansRequestToJSON(json: any): RequestCreateInboundPlansRequest {
    return RequestCreateInboundPlansRequestToJSONTyped(json, false);
}

export function RequestCreateInboundPlansRequestToJSONTyped(value?: RequestCreateInboundPlansRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plans': ((value['plans'] as Array<any>).map(RequestCreateInboundPlanRequestToJSON)),
    };
}

